import axios from 'axios';

// Dedicated client for the HRIS module on the Go backend.
// HRIS currently lives on the same Go backend as Project Management. Staging
// already injects REACT_APP_PM_API_ENDPOINT, so use it as the safe fallback
// instead of falling back to localhost in deployed builds.
const hrisApiUrl =
  process.env.REACT_APP_HRIS_API_ENDPOINT ||
  process.env.REACT_APP_PM_API_ENDPOINT ||
  'https://api-erp.cbqaglobal.co.id';

const apiHris = axios.create({
  baseURL: hrisApiUrl + '/api',
  withCredentials: true,
});

apiHris.interceptors.request.use((config) => {
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem('user') || '{}');
  } catch (error) {
    user = null;
  }

  const token = user?.token || user?.accessToken || localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiHris;
